// extracted by mini-css-extract-plugin
module.exports = {"carCard":"_35mbE","carImage":"_2QGru","outer":"_2B8O5","carName":"_2Yc07","price":"zWn62","message":"_2GAcZ"};